import { useMemo } from 'react'

import { Profile } from '@cash-web/protos/squareup/franklin/ProfileProto.pb'

import { AuthContext } from './AuthContext'

/**
 * A dummy auth provider for scoped sessions, where the profile is not available.
 */
export const ScopedAuthProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useMemo(() => ({ profile: {} as Profile, isLoading: false, isFetching: false, error: undefined }), [])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
